"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const functional_1 = require("./functional");
// order below is 1-indexed, since the regex match groups start at 1
const DATE_RES = [
    {
        // MM/DD/YYYY || MM-DD-YYYY
        re: /^([0-1]?[0-9])[/-]([0-3]?[0-9])[/-](\d{4})$/,
        order: [3, 1, 2],
    },
    {
        // YYYY/MM/DD
        re: /^(\d{4})[/-]([0-1]?[0-9])[/-]([0-3]?[0-9])$/,
        order: [1, 2, 3],
    },
];
const reTester = ({ re }, string) => re.test(string);
const execute = string => reAndOrder => {
    if (!reAndOrder)
        return [];
    const { re, order } = reAndOrder;
    const match = re.exec(string);
    // In the Date constructor, months are 0-index, so subtracting 1 from
    // month in advance
    return [match[order[0]], parseInt(match[order[1]], 10) - 1, match[order[2]]];
};
const dateStringConverter = dateString => (0, functional_1.pipe)(DATE_RES)((0, functional_1.find)(dateTest => reTester(dateTest, dateString)), execute(dateString), (0, functional_1.map)(n => parseInt(n, 10)), arr => (arr.length === 0 ? null : arr));
exports.default = dateStringConverter;
//# sourceMappingURL=date-string-converter.js.map